var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666832 9.33317H2.66683L4.66683 11.9998H12.0002L8.66683 0.666504L11.3335 0.666504L18.0002 11.9998L25.3335 11.9998C25.8891 11.9998 26.3613 12.1943 26.7502 12.5832C27.1391 12.9721 27.3335 13.4443 27.3335 13.9998C27.3335 14.5554 27.1391 15.0276 26.7502 15.4165C26.3613 15.8054 25.8891 15.9998 25.3335 15.9998L18.0002 15.9998L11.3335 27.3332H8.66683L12.0002 15.9998H4.66683L2.66683 18.6665H0.666832L2.00016 13.9998L0.666832 9.33317Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.ed052b36348f59495f7bfb8e55687e03.svg";
export { ForwardRef as ReactComponent };